import ContentPageTemplate from '@/components/ContentPageTemplate';

export default function ServiceAreas() {
  const pageData = {
    title: "Service Areas - South Florida Impact Windows & Doors",
    metaDescription: "Snap Windows installs impact windows and doors across Miami-Dade, Broward, and Palm Beach counties. See every South Florida city we serve.",
    canonicalPath: "/service-areas",
    
    directAnswer: (
      <p>
        SNAP Windows provides professional impact window and door installation services throughout South Florida, including Miami-Dade County, Broward County, and Palm Beach County. We serve residential and commercial properties across all major cities and municipalities in the tri-county area.
      </p>
    ),

    breadcrumbs: [
      { label: "Home", link: "/" },
      { label: "Service Areas" }
    ],

    sections: [
      {
        title: "Miami-Dade County",
        testId: "miami-dade",
        content: (
          <p>
            We serve all of Miami-Dade County, from Miami Beach to Homestead, providing impact window and door installation with proper HVHZ (High-Velocity Hurricane Zone) compliance.
          </p>
        ),
        bullets: [
          "Miami",
          "Kendall",
          "Coral Gables",
          "Aventura",
          "Hialeah",
          "Doral",
          "Homestead",
          "North Miami",
          "Cutler Bay",
          "Palmetto Bay",
          "Sweetwater",
          "West Miami",
          "Sunny Isles Beach",
          "Miramar"
        ]
      },

      {
        title: "Broward County",
        testId: "broward",
        content: (
          <p>
            Our services extend throughout Broward County, covering Fort Lauderdale, Pompano Beach, and surrounding communities.
          </p>
        ),
        bullets: [
          "Fort Lauderdale",
          "Pompano Beach",
          "Hollywood",
          "Pembroke Pines",
          "Coral Springs",
          "Davie",
          "Plantation",
          "Sunrise",
          "Weston"
        ]
      },

      {
        title: "Palm Beach County",
        testId: "palm-beach",
        content: (
          <p>
            We also serve select areas in Palm Beach County, providing the same quality installation and customer service.
          </p>
        ),
        bullets: [
          "Boca Raton",
          "Boynton Beach",
          "Delray Beach",
          "West Palm Beach"
        ]
      },

      {
        title: "Why Choose SNAP Windows in South Florida",
        testId: "why-choose",
        bullets: [
          "Licensed and insured general contractor serving all three counties",
          "HVHZ compliance expertise for Miami-Dade and Broward coastal areas",
          "Full permit handling and coordination with local building departments",
          "Manufacturer-certified installations for all product tiers",
          "Same professional service across our entire service area"
        ]
      }
    ],

    relatedLinks: [
      {
        title: "Get Your Quote",
        url: "/get-quote?src=service_areas",
        description: "Upload photos and receive pricing"
      },
      {
        title: "Pricing Guide",
        url: "/impact-window-cost-miami",
        description: "See real pricing examples"
      },
      {
        title: "Permit Process",
        url: "/impact-window-permits-miami-dade",
        description: "Learn about South Florida permits"
      }
    ],

    ctaText: "Ready to Get Started?",
    ctaSubtext: "Upload photos now. Receive Good/Better/Premium pricing within 24 hours."
  };

  return <ContentPageTemplate {...pageData} />;
}
